import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "src/components/base/button";

/**
 * The properties for {@link GenerateScimTokenDialog}
 */
export type GenerateScimToken = {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for   */
    onSubmit: () => void;
};

/**
 * Dialog to expire the device key
 */
export default function GenerateScimTokenDialog(props: GenerateScimToken) {
    const [t] = useTranslation("dialog-generate-scim-token");
    const [tg] = useTranslation();

    return (
        <Dialog open={props.isOpen} onClose={props.onClose}>
            <DialogTitle>{t("heading.generate-scim-token")}</DialogTitle>
            <DialogDescription>{t("description.generate-scim-token-proceed")}</DialogDescription>
            <DialogActions>
                <Button onClick={props.onClose}>{tg("button.cancel")}</Button>
                <Button color={"red"} onClick={props.onSubmit}>
                    {t("button.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
